// extracted by mini-css-extract-plugin
module.exports = {"Thanks":"_2ZnRq_cL","thanksContent":"_1Orb-YQJ","header":"_2s2stjHc"};
    if(module.hot) {
      // 1754514988196
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  